import AboutContainer from './About.container';
import About from './About';

export default AboutContainer(About);
